const About = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8">About Interface Research</h1>
      
      <section className="mb-12">
        <p className="text-lg text-glam-secondary dark:text-gray-300 mb-6">
          Interface Research specializes in transforming cultural heritage collections into 
          intelligent, accessible digital platforms. We bridge the gap between traditional 
          archival practices and cutting-edge technology to serve galleries, libraries, 
          archives, and museums (GLAM) worldwide.
        </p>
        
        <p className="text-lg text-glam-secondary dark:text-gray-300 mb-6">
          Founded with a mission to democratize access to cultural knowledge, we combine 
          expertise in information science, artificial intelligence, and cloud architecture 
          to create solutions that preserve the past while building for the future.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-bold mb-6">Our Approach</h2>
        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold mb-2">Collection-First Design</h3>
            <p className="text-glam-secondary dark:text-gray-300">
              Every project begins with a deep understanding of your collection's unique 
              characteristics, metadata standards, and preservation requirements.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-semibold mb-2">Scalable Architecture</h3>
            <p className="text-glam-secondary dark:text-gray-300">
              We design systems that grow with your collection, from thousands to millions 
              of items, without compromising performance or accessibility.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-semibold mb-2">User-Centered Experience</h3>
            <p className="text-glam-secondary dark:text-gray-300">
              Whether serving researchers, educators, or the public, we create intuitive 
              interfaces that make complex collections approachable and engaging.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-bold mb-6">Our Values</h2>
        <ul className="space-y-4 text-glam-secondary dark:text-gray-300">
          <li className="flex items-start">
            <span className="text-glam-accent mr-3">•</span>
            <span><strong>Preservation:</strong> Digital solutions that ensure long-term accessibility and integrity of cultural materials</span>
          </li>
          <li className="flex items-start">
            <span className="text-glam-accent mr-3">•</span>
            <span><strong>Innovation:</strong> Leveraging the latest technologies while respecting traditional archival principles</span>
          </li>
          <li className="flex items-start">
            <span className="text-glam-accent mr-3">•</span>
            <span><strong>Accessibility:</strong> Making cultural heritage available to diverse audiences worldwide</span>
          </li>
          <li className="flex items-start">
            <span className="text-glam-accent mr-3">•</span>
            <span><strong>Collaboration:</strong> Working closely with institutions to understand and meet their unique needs</span>
          </li>
        </ul>
      </section>

      <section className="bg-glam-light dark:bg-gray-900 p-8 rounded-lg">
        <h2 className="text-2xl font-bold mb-4">Partner With Us</h2>
        <p className="text-glam-secondary dark:text-gray-300 mb-6">
          We're passionate about helping cultural institutions unlock the full potential 
          of their collections. Whether you're looking to digitize, organize, or create 
          new ways to engage with your materials, we're here to help.
        </p>
        <a
          href="/contact"
          className="inline-block px-6 py-3 bg-glam-accent text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Get in Touch
        </a>
      </section>
    </div>
  );
};

export default About;